
import { Component, Prop } from "vue-property-decorator";
import CommonPopup from "../../../components/CommonPopup.vue";
import { CommonImagesVO, FileVO } from "@/views/biz/review/vo/file.vo";

@Component
export default class ImagesViewPop extends CommonPopup {
  @Prop()
  title!: string;
  @Prop()
  images!: Array<CommonImagesVO>;

  // 비디오플레이어 옵션
  playerOptionsDefault = {
    muted: true,
    playsinline: true,
    language: "en",
    controls: true,
    playbackRates: [0.7, 1.0, 1.5, 2.0], //재생속도
  };

  // 상품 이미지 swiper
  swiperReviewImgOptions = {
    slidesPerView: 1,
    lazy: true,
    loop: false,
    freeMode: false,
    pagination: {
      el: ".swiper-pagination",
      type: "fraction",
    },
  };

  // methods

  // 비디오플레이어 옵션
  getPlayerOptions(options: any) {
    return Object.assign(this.playerOptionsDefault, options);
  }

  created() {
    if(!this.images) {
      this.$router.go(-1);
    }
  }
}
